const mutations = {
  mutationSetDataEditPartner(state, payload) {
    state.dataPartner = payload;
  },

  mutationSetDataEditPartnerProductCategoriesById(state, payload) {
    state.editProductCategory = payload;
  },

  mutationIsComingFromCreatePartner(state, payload) {
    state.isComingFromCreatePartner = payload;
  },

  mutationListProductCategoriesByOrganization(state, payload) {
    state.listProductCategoriesByOrganization = payload;
  },
  mutationSetPartnerProducts(state, payload) {
    const uniqueObjects = payload.filter(
      (obj1) => !state.partnerProducts.some((obj2) => obj1.id === obj2.id),
    );
    state.partnerProducts = state.partnerProducts.concat(uniqueObjects);
  },
  resetSetPartnerProducts(state, payload) {
    state.partnerProducts = payload;
  },
  mutationSetPartnerDetail(state, payload) {
    state.dataPartner = payload;
  },
  resetPartnerDetail(state) {
    state.dataPartner = {};
  },
};

export default mutations;
